module.exports = __webpack_public_path__ + "static/media/crowdsource.d1aa4fa9.svg";